import { Component, ElementRef, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-modal-gas-meter-maintenance-remove',
  template: `
  <ng-template #modalGasMeterMaintenanceRemove let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Concluir mantenimiento de medidor de gas</h5>
      <button type="button" (click)="dismiss()" data-dismiss="modal" aria-label="Close" class="btn btn-link text-dark">
        <fa-icon [icon]="icons.faTimes"></fa-icon>
      </button>
    </div>
    <div class="modal-body p-4">
      <form [formGroup]="meterForm" (ngSubmit)="onSubmit()">
        <div class="form-group mt-2">
          <label for="consumption">Lectura posterior al mantenimiento</label>
          <input type="number" formControlName="last_read" class="form-control form-control-lg" id="last_read" placeholder="">
        </div>
        <div class="form-group mt-4 text-end">
          <button type="submit" class="btn btn-warning btn-lg rounded-5"><fa-icon [icon]="icons.faHammer" class="me-2"></fa-icon> Terminar mantenimiento</button>
        </div>
      </form>
    </div>
  </ng-template>
  `,
  styleUrls: []
})
export class ModalGasMeterMaintenanceRemoveComponent {
  @Input() set meter(value: any) {
    if (this.meterForm.contains('id')) {
      this.meterForm.patchValue({
        id: value?.id ?? ''
      })
    }
  };
  @Output() updateDismiss: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalGasMeterMaintenanceRemove') modalGasMeterMaintenanceRemove !: ElementRef;

  meterForm: FormGroup = new FormGroup({});
  private modalRef: NgbModalRef | undefined;

  constructor(
    public icons: IconsService,
    private store: SettlementsService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {
    this.initForm();
  }

  initForm() {
    this.meterForm = this.fb.group({
      id: [''],
      last_read: [''],
      maintenance: [false],
    });
  }

  onSubmit() {
    this.store.updateGasMeter(this.meterForm.value.id, this.meterForm.value).subscribe({
      next: (res: any) => {
        this.toastr.success('Mantenimiento actualizado');
        this.dismiss();
      },
      error: (err: any) => {
        this.toastr.error('Error al actualizar mantenimiento');
      }
    });
  }

  openModal(modalContent: TemplateRef<any>) {
    this.modalRef = this.modalService.open(modalContent);
  }

  dismiss() {
    if (this.modalRef) {
      this.updateDismiss.emit();
      this.modalRef.dismiss();
    }
  }

}
